// @ts-nocheck — generated mock data ported from the design prototype; real types land in Phase 3.
// Boost Blenz Detox App — Help knowledge base + Getting Started content.
// One source of truth: every Q&A feeds the chat assistant's answers AND the
// browse topics. The onboarding content feeds both Getting Started variants.
// Answers are written to match the physical Detox Tracker pamphlet rules.

export const BB_HELP: any = (function () {

  // ── Topics (also used as guided chat entry buttons) ──────────────────────
  const TOPICS = [
    { id: 'diet',      label: 'Foods to eat',     icon: 'leaf',  color: '#2e6b32', wash: '#d8ecd1' },
    { id: 'water',     label: 'Water intake',     icon: 'drop',  color: '#246d7f', wash: '#dcf1f7' },
    { id: 'fasting',   label: 'Breakfast & fasting', icon: 'sun', color: '#a15a12', wash: '#ffe8d8' },
    { id: 'symptoms',  label: 'How I might feel', icon: 'heart', color: '#b03a52', wash: '#fbe9e8' },
    { id: 'timing',    label: 'When to take it',  icon: 'clock', color: '#3c3291', wash: '#e4dffb' },
    { id: 'binder',    label: 'The Binder',       icon: 'clock', color: '#5d51b3', wash: '#e4dffb' },
    { id: 'order',     label: 'What order',       icon: 'list',  color: '#8a6d00', wash: '#fbf3c9' },
    { id: 'reminders', label: 'Reminders',        icon: 'bell',  color: '#5a5a5a', wash: '#f0eff2' },
  ];

  // ── Knowledge base. `q` = canonical question, `short` = one-line chat answer,
  //    `body` = paragraphs/bullets, `keys` = extra match terms, `source` = the
  //    guide section it was composed from. `escalate:true` means always human. ──
  const KB = [
    {
      id: 'diet-eat', topic: 'diet',
      q: 'What foods should I eat during a detox?',
      chips: ['What can I eat?', 'Foods to avoid'],
      short: 'Keep it simple and whole: cooked vegetables, clean proteins, rice, and plenty of water. Go light and gentle while you cleanse.',
      body: [
        { t: 'p', v: 'You don’t need a strict diet — the goal is to give your body less to process so the detox can do its work.' },
        { t: 'h', v: 'Lean into' },
        { t: 'ul', v: ['Cooked vegetables and leafy greens', 'Clean proteins — chicken, fish, eggs', 'Rice, oats, and simple whole grains', 'Fresh fruit and bone broth'] },
        { t: 'h', v: 'Go easy on' },
        { t: 'ul', v: ['Sugar, alcohol, and fried food', 'Processed and packaged snacks', 'Too much coffee'] },
      ],
      source: 'Getting Started · Foods to eat',
    },
    {
      id: 'water', topic: 'water',
      q: 'How much water should I drink?',
      chips: ['How much water?', 'Why more water?'],
      short: 'Aim for about half your body weight in ounces each day — roughly 8–10 glasses. Water helps carry what you’re releasing out of the body.',
      body: [
        { t: 'p', v: 'Water is one of the most important parts of a detox. As your body releases toxins, water flushes them out — without enough, you’re more likely to feel tired or headachy.' },
        { t: 'ul', v: ['Aim for roughly half your body weight in ounces per day', 'Sip steadily through the day rather than all at once', 'Add a pinch of sea salt or lemon if you’d like'] },
        { t: 'p', v: 'Remember to keep the 30-minute gap after your detox before you eat or drink anything other than water.' },
      ],
      source: 'Getting Started · Water intake',
    },
    {
      id: 'fasting', topic: 'fasting',
      q: 'Do I need to eat breakfast, or can I fast?',
      chips: ['Can I fast?', 'Do I eat breakfast?'],
      short: 'Either is fine. Take your detox first thing on an empty stomach, then eat breakfast when you’re ready — or skip it if you normally fast. The app adjusts your Binder timing to your choice.',
      body: [
        { t: 'p', v: 'Your detox always comes first, on an empty stomach, before anything else.' },
        { t: 'h', v: 'If you eat breakfast' },
        { t: 'p', v: 'Wait 30 minutes after your detox, then eat normally.' },
        { t: 'h', v: 'If you fast or skip breakfast' },
        { t: 'p', v: 'That’s perfectly fine — there’s nothing in your stomach, so on Binder days your 2-hour timer can start right away.' },
        { t: 'p', v: 'We ask this once when you set up, and you can change it any time in Settings.' },
      ],
      source: 'Getting Started · Breakfast & fasting',
    },
    {
      id: 'symptoms', topic: 'symptoms',
      q: 'What symptoms are normal during a detox?',
      chips: ['Is this normal?', 'When to worry'],
      short: 'Mild tiredness, headaches, or changes in digestion in the first few days are common as your body adjusts. Drink more water and rest. Anything severe or lasting — please contact us or your doctor.',
      body: [
        { t: 'h', v: 'Usually normal (first few days)' },
        { t: 'ul', v: ['Feeling a little tired or low-energy', 'A mild headache', 'Changes in digestion', 'Feeling slightly “off” as your body adjusts'] },
        { t: 'p', v: 'These often ease when you drink more water and slow down for a day or two.' },
        { t: 'h', v: 'Please check with us or a doctor' },
        { t: 'ul', v: ['Symptoms that are severe or don’t improve', 'A high fever, or anything that worries you', 'If you’re pregnant, nursing, or on medication'] },
      ],
      source: 'Getting Started · How you might feel',
      escalate: true,
    },
    {
      id: 'timing', topic: 'timing',
      q: 'When should I take my detox?',
      chips: ['When do I take it?', 'The 30-minute rule'],
      short: 'Each morning, on an empty stomach, before food or coffee. Then wait 30 minutes before eating or drinking anything but water.',
      body: [
        { t: 'ul', v: ['Take it first thing in the morning', 'Empty stomach — before food, coffee, or other supplements', 'One level scoop, stirred into water', 'Wait 30 minutes before eating'] },
        { t: 'p', v: 'The app shows you a short how-to video for the exact jar you’re on, and a big button to check it off.' },
      ],
      source: 'Getting Started · When to take it',
    },
    {
      id: 'binder', topic: 'binder',
      q: 'How does the Binder timing work?',
      chips: ['When do I take the Binder?', 'Why the 2-hour wait?'],
      short: 'On Binder days, take it at least 2 hours after eating, then wait 2 more hours before eating again. The app watches the clock and pings you when the window opens — no math needed.',
      body: [
        { t: 'p', v: 'The Binder works best on an empty stomach so it isn’t soaking up your food instead of what you’re clearing out.' },
        { t: 'ul', v: ['Wait 2+ hours after your last food, supplement, or medicine', 'Take the Binder', 'Wait 2 hours after before eating again'] },
        { t: 'p', v: 'You never have to track this yourself — tap “done eating” and we’ll notify you the moment it’s time.' },
      ],
      source: 'Getting Started · The Binder',
    },
    {
      id: 'order', topic: 'order',
      q: 'What order do I do the detoxes in?',
      chips: ['What order?', 'One at a time?'],
      short: 'One at a time, in order: Liver → Kidney → Parasite → Heavy Metal. Finish each before starting the next — the app unlocks them for you.',
      body: [
        { t: 'p', v: 'The kit is designed as a sequence. Each stage prepares your body for the next, so it matters that you finish one before moving on.' },
        { t: 'ol', v: ['Liver Cleanse — 14 days', 'Kidney Cleanse — 14 days', 'Parasite Killer — 30 days', 'Heavy Metal Detox — 30 days'] },
        { t: 'p', v: 'You don’t have to remember any of this — the Today screen always shows the one you’re on, and the next one stays locked until you’re done.' },
      ],
      source: 'Getting Started · What order',
    },
    {
      id: 'reminders', topic: 'reminders',
      q: 'How do I set reminders so I don’t forget?',
      chips: ['Set up reminders', 'Add to home screen'],
      short: 'Turn on reminders in Settings, and add the app to your home screen — then your alerts include one-tap buttons (“Done”, “Taken”, “Snooze”) so you never miss a dose.',
      body: [
        { t: 'ul', v: ['Open Settings → Reminders and turn on your morning detox alert', 'Add Boost Blenz to your home screen for lock-screen buttons', 'On Binder days we ping you when the 2-hour window opens'] },
        { t: 'p', v: 'Adding to your home screen takes about 20 seconds — we’ll walk you through it.' },
      ],
      source: 'Getting Started · Reminders',
    },
    {
      id: 'missed', topic: 'timing',
      q: 'What if I miss a day?',
      chips: ['I missed a day'],
      short: 'No problem — just take it the next day. Never take two doses in one day to catch up.',
      body: [
        { t: 'p', v: 'Missing a day won’t undo your progress. Take your detox the next morning as usual.' },
        { t: 'p', v: 'The one rule: never double up. Two doses in one day isn’t better and can make you feel unwell.' },
      ],
      source: 'Getting Started · When to take it',
    },
  ];

  // Questions we deliberately DON'T answer with AI — health/medical/personal.
  const HUMAN_ONLY = ['medication', 'pregnan', 'nursing', 'breastfeed', 'doctor', 'refund', 'return', 'order status', 'shipping', 'allergic', 'diabet', 'blood pressure', 'my order', 'where is my'];

  // ── matcher: score free text against KB, return best + confidence ─────────
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim(); }
  function match(query) {
    const nq = norm(query);
    if (!nq) return { conf: 0, hits: [] };
    for (const term of HUMAN_ONLY) { if (nq.indexOf(term) !== -1) return { conf: 0, hits: [], human: true }; }
    const words = nq.split(' ').filter(w => w.length > 2);
    const scored = KB.map(k => {
      const hay = norm(k.q + ' ' + k.short + ' ' + (k.chips || []).join(' ') + ' ' + k.topic);
      let s = 0;
      words.forEach(w => { if (hay.indexOf(w) !== -1) s += 1; });
      // exact-ish question boost
      if (norm(k.q) === nq) s += 5;
      (k.chips || []).forEach(c => { if (norm(c) === nq) s += 5; });
      return { k, s };
    }).filter(o => o.s > 0).sort((a, b) => b.s - a.s);
    if (!scored.length) return { conf: 0, hits: [] };
    const top = scored[0];
    const conf = Math.min(1, top.s / Math.max(2, words.length));
    return { conf, hits: scored.slice(0, 3).map(o => o.k), best: top.k };
  }
  function byId(id) { return KB.find(k => k.id === id); }
  function byTopic(id) { return KB.filter(k => k.topic === id); }

  // ── popular quick questions (chips shown at start) ────────────────────────
  const POPULAR = ['What can I eat?', 'How much water?', 'Can I fast?', 'When do I take the Binder?', 'I missed a day', 'Is this normal?'];

  // ── Getting Started: the intro content, shared by both variants ───────────
  // Each step: eyebrow, title, lead, optional bullets, image (hero) or placeholder,
  // optional `setup` for the interactive breakfast question.
  const STEPS = [
    {
      id: 'welcome', eyebrow: 'Welcome', title: 'Let’s get you started',
      lead: 'A few short things to know before your first morning. This takes about 2 minutes — and you can come back to it any time from the Start tab.',
      img: null, mark: true, band: '#3c3291', ink: '#fff',
    },
    {
      id: 'order', eyebrow: 'Step 1', title: 'One at a time, in order',
      lead: 'Your kit is a sequence. Finish each detox before the next — the app unlocks them for you, so there’s nothing to track.',
      order: ['Liver Cleanse', 'Kidney Cleanse', 'Parasite Killer', 'Heavy Metal'],
      band: '#faf3e8',
    },
    {
      id: 'timing', eyebrow: 'Step 2', title: 'Each morning, empty stomach',
      lead: 'Take your detox first thing, before food or coffee. Then wait 30 minutes before eating.',
      bullets: ['One level scoop, stirred into water', 'Before food, coffee, or supplements', 'Wait 30 minutes before eating'],
      img: 'products/hero-parasite-v4.png', band: '#fbe9e8',
    },
    {
      id: 'fasting', eyebrow: 'Step 3', title: 'Breakfast, or fasting?',
      lead: 'Your detox comes first either way. Tell us how you usually start your day and we’ll set your Binder timing to match.',
      setup: true, band: '#ffe8d8',
    },
    {
      id: 'diet', eyebrow: 'Step 4', title: 'Eat simple, eat clean',
      lead: 'No strict diet — just give your body less to process. Lean into whole foods and go easy on the rest.',
      twoCol: { good: ['Cooked veg & greens', 'Clean proteins', 'Rice & whole grains', 'Fruit & broth'], bad: ['Sugar & alcohol', 'Fried & processed food', 'Too much coffee'] },
      band: '#d8ecd1',
    },
    {
      id: 'water', eyebrow: 'Step 5', title: 'Drink plenty of water',
      lead: 'Water carries out what you’re releasing. Aim for about half your body weight in ounces — roughly 8–10 glasses a day.',
      bullets: ['Sip steadily through the day', 'A pinch of sea salt or lemon is great', 'Water is fine during your 30-min wait'],
      img: 'products/hero-kidney.png', band: '#dcf1f7',
    },
    {
      id: 'symptoms', eyebrow: 'Step 6', title: 'How you might feel',
      lead: 'A little tired or a mild headache in the first days is common as your body adjusts. Rest and drink water.',
      note: 'Anything severe or lasting — or if you’re pregnant, nursing, or on medication — check with us or your doctor.',
      band: '#faf3e8',
    },
    {
      id: 'reminders', eyebrow: 'Last step', title: 'Never miss a dose',
      lead: 'Turn on reminders and add Boost Blenz to your home screen — your alerts get one-tap buttons so a check-off is effortless.',
      reminders: true, band: '#3c3291', ink: '#fff',
    },
  ];

  const BREAKFAST_OPTIONS = [
    { id: 'eats', title: 'I eat breakfast', sub: 'Detox first, then breakfast after 30 min' },
    { id: 'supps', title: 'Just supplements', sub: 'No meal, but I take other supplements' },
    { id: 'fasts', title: 'I fast / skip it', sub: 'Nothing until later — timer can start right away' },
  ];

  return { TOPICS, KB, POPULAR, match, byId, byTopic, STEPS, BREAKFAST_OPTIONS };
})();